// import ColleagueDetail from "./theme1"
import Theme4 from "./theme4";

export function ColleagueDetails(props) {
    const { theme } = props
    switch (theme) {
        // case 'theme1':
        //     return <ColleagueDetail {...props} />
        case 'theme4':
            return <Theme4 {...props} />
        default:
            return <Theme4 {...props} />
    }
}

export default ColleagueDetails;